import { Episode, Video } from 'types/api/media';
import ProgressBar, {
  ProgressBarTemplateSpec,
} from 'components/common/progressBar/ProgressBar';
import { WithProgress } from 'services/cwData';

export interface MediaProgressBarTemplateSpec extends ProgressBarTemplateSpec {
  mediaItem: WithProgress<Episode | Video> | undefined;
}

const DEFAULT_WIDTH = 380;
const DEFAULT_HEIGHT = 10;

export default class MediaProgressBar extends ProgressBar<MediaProgressBarTemplateSpec> {
  override _width = DEFAULT_WIDTH;

  static override get defaultWidth() {
    return DEFAULT_WIDTH;
  }

  static override get defaultHeight() {
    return DEFAULT_HEIGHT;
  }

  set mediaItem(mediaItem: MediaProgressBarTemplateSpec['mediaItem']) {
    if (!mediaItem) {
      this._progressPercent = 0;
      return;
    }

    if (mediaItem.isComplete) {
      this.progressPercent = 1;
      return;
    }

    const { durationSecs } = mediaItem;
    const durationSecsParsed = parseInt(durationSecs);

    this.progressPercent = (mediaItem.progress ?? 0) / durationSecsParsed;
  }
}
